export default __webpack_public_path__ + "static/media/photo1.719547a2.jpg";